/**
 * RteBlock
 * @module components/RteBlock
 */
import RichText from 'components/ui/RichText';
import Layout from 'components/ui/Layout';
import { useSiteType } from 'context/siteType.context';
import clsx from 'clsx';

interface RteBlockData {
	text: string;
	backgroundColor: string;
}

const RteBlock = ({ text, backgroundColor }: RteBlockData) => {
	const siteType = useSiteType();

	return (
		<Layout backgroundColor={backgroundColor} className="mb-10">
			<div className="max-w-full sm:max-w-2/3">
				<RichText
					className={clsx(
						siteType === 'LindabGroup'
							? 'text-lgDarkGray'
							: backgroundColor === 'blue'
							? 'text-white'
							: 'text-black'
					)}
					text={text}
				/>
			</div>
		</Layout>
	);
};

export default RteBlock;
